export default "__VITE_ASSET__BuywYR5j__"